<app-block-slideshow />
<!-- Muestra el apartado de caja valor -->
<!-- <app-buttons-slideshow /> -->
<!-- Muestra todo el apartado de productos lista, -->
<app-product-slideshow />
<app-page-home />

<div class="container bg-white" style="padding: 35px 10px 20px">
  <app-block-brands-b2c />
</div>
